import {Compartment, CompartmentLite, CompartmentWithoutRentals, CompartmentWithRentals} from '../common/types/compartment'
import {
  GQL_CompartmentFragment,
  GQL_CompartmentLiteFragment,
  GQL_CompartmentWithOngoingRentalFragment,
  GQL_CompartmentWithRentalsFragment,
} from '../generated/graphql'
import {transformCompartmentProduct} from './transformCompartmentProduct'
import {transformRental} from './transformRental'

export const transformCompartment = (gqlCompartment: GQL_CompartmentWithOngoingRentalFragment): Compartment => ({
  ...transformCompartmentWithoutRentals(gqlCompartment),
  rentalsCount: gqlCompartment.rentalsCount,
  latestRental: gqlCompartment.latestRental
    ? {
        id: gqlCompartment.latestRental.id,
        rentStart: gqlCompartment.latestRental.rentStart ?? undefined,
      }
    : undefined,
  ongoingRental: gqlCompartment.ongoingRental
    ? {
        id: gqlCompartment.ongoingRental.id,
        maxRentTimeInMinutes: gqlCompartment.ongoingRental.maxRentTimeInMinutes,
        rentBy: {
          id: gqlCompartment.ongoingRental.rentBy.id,
          email: gqlCompartment.ongoingRental.rentBy.email ?? undefined,
        },
        rentStart: gqlCompartment.ongoingRental.rentStart,
      }
    : undefined,
})

export const transformCompartmentLite = (gqlCompartment: GQL_CompartmentLiteFragment): CompartmentLite => ({
  ...transformCompartmentWithoutRentals(gqlCompartment),
  ongoingRental: gqlCompartment.ongoingRental
    ? {id: gqlCompartment.ongoingRental.id, rentStart: gqlCompartment.ongoingRental.rentStart ?? undefined}
    : undefined,
})

export const transformCompartmentWithRentals = (gqlCompartment: GQL_CompartmentWithRentalsFragment): CompartmentWithRentals => ({
  ...transformCompartment(gqlCompartment),
  rentals: gqlCompartment.rentals.map(transformRental),
})

export const transformCompartmentWithoutRentals = (gqlCompartment: GQL_CompartmentFragment): CompartmentWithoutRentals => ({
  id: gqlCompartment.id,
  circuitBoardPort: gqlCompartment.circuitBoardPort,
  locked: gqlCompartment.locked ?? false,
  private: gqlCompartment.private ?? false,
  product: transformCompartmentProduct(gqlCompartment.product),
  name: gqlCompartment.name ?? undefined,
})
